import { createServerFn } from "@tanstack/react-start";
import type { Project, AllProjectsPayload } from "./types";

export const fetchProjects = createServerFn({ method: "GET" }).handler(
  async (): Promise<Project[]> => {
    const { wpListWebsiteProjects } = await import("./wp.server");
    return (await wpListWebsiteProjects()) ?? [];
  },
);

export const fetchAllProjectsWithCategories = createServerFn({ method: "GET" }).handler(
  async (): Promise<AllProjectsPayload> => {
    const { wpListAllProjectsWithCategories } = await import("./wp.server");
    return (await wpListAllProjectsWithCategories()) ?? { projects: [], categories: [] };
  },
);


export const fetchProjectsByCategory = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => {
    if (!data || typeof data.slug !== "string" || !/^[a-z0-9-]{1,64}$/.test(data.slug)) {
      throw new Error("Invalid category slug");
    }
    return { slug: data.slug };
  })
  .handler(async ({ data }): Promise<Project[]> => {
    const { wpListProjectsByCategory } = await import("./wp.server");
    return (await wpListProjectsByCategory(data.slug)) ?? [];
  });

export const fetchProjectBySlug = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => {
    if (!data || typeof data.slug !== "string" || data.slug.length > 200) throw new Error("Invalid slug");
    return { slug: data.slug };
  })
  .handler(async ({ data }): Promise<Project | null> => {
    const { wpGetWebsiteProject } = await import("./wp.server");
    return wpGetWebsiteProject(data.slug);
  });
